import { Tag, Text } from "@chakra-ui/react";
import XpPoint from "../../assets/icons/xpPoint";

type IProps = {
  value: number;
};

const Points = ({ value }: IProps) => {
  return (
    <Tag size={"lg"} p={".8rem"} bg={"#0C1C0D"} borderRadius={"2rem"}>
      <XpPoint color={"#4CAF50"} fontSize={"1.2rem"} />
      <Text pl={".5rem"} fontWeight={"bold"}>
        +{value}
      </Text>
    </Tag>
  );
};

export default Points;
